import React, {useState, useEffect} from 'react';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function TeamShortTermGoalAddForm() 
{
    const { app_user, team, team_member_role, setShortTermGoal, setTeamDisplayRefresh } = useCTAL();
    
    const [error, setError] = useState();
    const [form_changed_flag, setFormChangedFlag] = useState(false);
    const [add_stg_button_type, setAddSTGButtonType] = useState("btn btn-sm btn-secondary mt-2");
    const [results_display, setResultsDisplay] = useState(<></>); 
    const [admin_message_display, setAdminMessageDisplay] = useState(<></>); 

    const goal_desc_style = { height: 100 };
    const admin_message_style = { color: 'red' };
    const date_style = { width: 150 };
    
    useEffect(() =>
    {
        if (!team) return;

        var is_disabled = true;
        if (team_member_role == "Admin") {
            is_disabled = false;
            setAdminMessageDisplay(<></>);
        }
        else 
            setAdminMessageDisplay(<><span style={admin_message_style}><small>Adding Goals requires Team Admin privileges</small></span></>);      
        
        document.getElementById("add=stg-deadline-date").disabled = is_disabled;
        document.getElementById("add-goal-text").disabled = is_disabled;
        document.getElementById("add-goal-desc-text").disabled = is_disabled; 

    }, [team]);

    useEffect(() =>
    {
        if (DEBUG) console.log(`TeamShortTermGoalAddForm - form_changed_flag: ${form_changed_flag}`);
        if (!form_changed_flag)
            setAddSTGButtonType("btn btn-sm btn-secondary mt-2");
        else
            setAddSTGButtonType("btn btn-sm btn-primary mt-2");
    }, [form_changed_flag]);
    
    const reset_results = () => { setResultsDisplay(<></>); }
    const prepend_result = (result) => { setResultsDisplay( <> {result} {results_display} </>) }

    const create_result_success  = (message) => { return <div class="alert alert-success my-1 py-0" role="alert"><small>{message}</small></div>; }
    const create_result_error    = (message) => { return <div class="alert alert-danger  my-1 py-0" role="alert"><small>{message}</small></div>; }

    const handle_response = (res) => { 
        if (DEBUG) console.log(`TeamShortTermGoalEditForm - res.message: ${res.message}`);

        switch (res.result)
        {
            case "success" : setShortTermGoal(undefined); setTeamDisplayRefresh(true); break;
            case "error"   : prepend_result(create_result_error(res.message)); break;
            default: break;
        }
    }
    
    const add_short_term_goal = () => { 
        if ((!app_user) || (!team)) return;
        if (!form_changed_flag) return;
        if (team_member_role != "Admin") return;

        if (document.getElementById("add-goal-text").value == "") return;

        var type = "create_short_term_goal";
        var team_id = team.TeamID;
        var user_id = app_user.UserID;
        var user_full_name = app_user.UserFullName;
        
        var deadline_date = document.getElementById("add=stg-deadline-date").value;
        var goal          = document.getElementById("add-goal-text").value;
        var desc          = document.getElementById("add-goal-desc-text").value;

        var body = JSON.stringify({type, team_id, user_id, user_full_name, deadline_date, goal, desc});
       
        console.log(`TeamShortTermGoalAddForm - Send Create Short-Term Goal body: ${body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-set`, { method: "POST", body: body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: body })
            .then(response => response.json())
            .then(handle_response)
            .catch(setError);

        setFormChangedFlag(false);
    }
    
    const form_changed = () => { 
        setFormChangedFlag(true);
    }

    return ( 
        <>
            {admin_message_display}

            <div class="form-floating mt-2">
                <input id="add=stg-deadline-date" type="date" class="form-control" style={date_style} aria-label="Deadline Date" aria-describedby="basic-addon1" onChange={form_changed}/>
                <label class="select-floating-label" htmlFor="stg-deadline-date">Deadline Date</label>
            </div>

            <div id="add-goal-form" class="form-floating mt-2">
                <textarea id="add-goal-text" class="form-control" placeholder="Add Short-Term Goal here" onChange={form_changed}></textarea>
                <label htmlFor="edit-goal-form">Add Goal</label>
            </div>
            
            <div id="add-goal-desc-form" class="form-floating mt-2">
                <textarea id="add-goal-desc-text" class="form-control" style={goal_desc_style} placeholder="Add Goal Description here" onChange={form_changed}></textarea>
                <label htmlFor="add-goal-desc-form">Add Goal Description</label>
            </div>
            
            <div class="row">
                <div class="col text-end">                      
                    <a href="#" id="add-stg-btn" class={add_stg_button_type} onClick={ () => add_short_term_goal() }>Add Goal</a>
                </div>
            </div>

            {results_display}
        </>
    );
}